import { render } from "./DashboardComponent.vue?vue&type=template&id=69d0757c&scoped=true"
import script from "./DashboardComponent.vue?vue&type=script&lang=js"
export * from "./DashboardComponent.vue?vue&type=script&lang=js"

import "./DashboardComponent.vue?vue&type=style&index=0&id=69d0757c&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\City Hoardings\\City_Hoardings_Eticket\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69d0757c"]])

export default __exports__